import React from "react";
import Box from "ReusableComponents/Box";
import Chips from "Pages/components/Chips";
import Text from "ReusableComponents/Text";
import { COLORS } from "theme";

const BlogChips = ({ chips, small, author, publishedAt }) => {
  return (
    <>
      <Box display="flex" marginTop="32px" alignItems="center">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Text
            fontSize={small ? "8px" : "14px"}
            textColor={COLORS.white}
            margin={small ? 0 : "0 8px"}
          >
            {author}
          </Text>
          <Text
            fontSize={small ? "8px" : "14px"}
            textColor={COLORS.white}
            margin="0 8px"
          >
            {publishedAt}
          </Text>
          {chips?.map((item) => (
            <Chips
              text={item?.attributes?.category_name}
              small={small}
              key={item?.id}
            />
          ))}
        </Box>
      </Box>
    </>
  );
};

export default BlogChips;
